import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=bd59408a&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=ts&"
export * from "./UserPage.vue?vue&type=script&lang=ts&"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=bd59408a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd59408a",
  null
  
)

export default component.exports